import React, { Component, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { EyeInvisibleOutlined,EyeOutlined } from '@ant-design/icons';


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../../config';




const slide = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]



const Login = () => {

	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const history = useHistory();
	const [visible, setVisible]= useState(true);
	const [loading, setLoading] = useState(false);






	const handleSubmit = (e) => {
		// setError(null);
		// setLoading(true);
		e.preventDefault();
		axios.post(API_BASE_URL + '/login', { username: username, password: password }).then(response => {
			//console.log(response.data.accessToken);
			// 	console.log(response.data.message);
			// })
			// console.log('Login successful:', response.data);
			var status = response.data.status;
			console.log(response.data.status);
			if (status == 200) {
				localStorage.setItem('authToken', response.data.accessToken);
				// let token = response.data.accessToken;
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				setTimeout(() => {
					history.push("/dashboard");
				}, 3000);




				//   setTimeout(() => {
				// 	return history.push({
				// 		pathname: '/',
				// 		state: {
				// 		  data: token,
				// 		},
				// 	  })
				//   }, 3000);


				//setTimeout(()=> nav('/dashboard'),5000);

			} else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			//  console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


				});

		});
	}



	return (
		<div className="auth">
			<div className="auth_left">
				<div className="card" style={{ height: '500px', paddingTop: '90px' }}>

					<ToastContainer />
					<div className="text-center mb-2">
						<Link className="header-brand" to="/">
							{/* <i className="fe fe-command brand-logo" /> */}
							<img src='assets/images/pebble-hrm-logo.svg' width={150} />
						</Link>
					</div>
					<div className="card-body">
						<div className="card-title">Login to your account</div>
						{/* <div className="form-group">
								<select className="custom-select">
									<option>HR Dashboard</option>
									<option>Project Dashboard</option>
									<option>Job Portal</option>
								</select>
							</div> */}

						<form onSubmit={handleSubmit}>
							<div className="form-group">
								<label className="form-label">
									Username
								</label>
								<input
									type="text" name="username"
									className="form-control"
									id="username"
									aria-describedby="emailHelp"
									placeholder="Enter Username" value={username}
									onChange={(e) => setUsername(e.target.value)}
								/>
							</div>
							<div className="form-group">
								{/* <label className="form-label">
									Password
									<Link className="float-right small" to="/forgotpassword">
										I forgot password
									</Link>
								</label> */}


								<label className="form-label">
									Password
								</label>
								<div className="row gutters-xs">
	
                                <div className="col">
												
								<input
									type={visible ? "password": "text"} name="password"
									className="form-control"
									id="exampleInputPassword1"
									placeholder="Enter Password" value={password}
									onChange={(e) => setPassword(e.target.value)}
								/>
								</div>
								<span className="col-auto">
									<button className="btn btn-secondary" type="button" onClick={()=>setVisible(!visible)}>{visible ? <EyeInvisibleOutlined  /> : <EyeOutlined />}
									</button>


								
									</span>
								
							</div>
							</div>
							{/* <div className="form-group">
								<label className="custom-control custom-checkbox">
									<input type="checkbox" className="custom-control-input" />
									<span className="custom-control-label">Remember me</span>
								</label>
							</div> */}
							<div className="form-footer">
								<button type="submit" className="btn btn-primary btn-block">Click to login</button>
								{/* <a className="btn btn-primary btn-block" href="/">
								Click to login
							</a> */}
							</div>
						</form>
					</div>
					
				</div>
			</div>
			<div className="auth_right">
				<div className="carousel slide" data-ride="carousel" data-interval={3000}>
					<div className="carousel-inner">
						{slide.map((s) => {
							return (
								<div className={"carousel-item " + (s == 1 ? 'active' : null)}>
									<img src={`assets/images/brochures/c${s}.jpeg`} className="img-fluid" alt="login page" />
									<div className="px-4 mt-4">
										{/* <h4>{i}</h4>
											<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p> */}
									</div>
								</div>
							)
						})}


						{/* <div className="carousel-item">
								<img src="assets/images/slider1.svg" className="img-fluid" alt="login page" />
								<div className="px-4 mt-4">
									<h4>Fully Responsive</h4>
									<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
								</div>
							</div>
							<div className="carousel-item">
								<img src="assets/images/slider2.svg" className="img-fluid" alt="login page" />
								<div className="px-4 mt-4">
									<h4>Quality Code and Easy Customizability</h4>
									<p>There are many variations of passages of Lorem Ipsum available.</p>
								</div>
							</div>
							<div className="carousel-item">
								<img src="assets/images/slider3.svg" className="img-fluid" alt="login page" />
								<div className="px-4 mt-4">
									<h4>Cross Browser Compatibility</h4>
									<p>Overview We're a group of women who want to learn JavaScript.</p>
								</div>
							</div> */}
					</div>
				</div>
			</div>
		</div>
	);
}


export default Login;